import { memo } from 'react';
import xss from 'xss';
import { jsx } from 'react/jsx-runtime';

var Truncate = function Truncate(_ref) {
  var _ref$maxLines = _ref.maxLines,
      maxLines = _ref$maxLines === void 0 ? 3 : _ref$maxLines,
      content = _ref.content;
  var ignoreTagAttr = ["class"];
  return /*#__PURE__*/jsx("div", {
    className: "eb-truncate",
    style: {
      WebkitLineClamp: maxLines,
      padding: 0
    },
    dangerouslySetInnerHTML: {
      __html: xss(content, {
        onIgnoreTagAttr: function onIgnoreTagAttr(tag, name, value) {
          return ignoreTagAttr.includes(name) ? "".concat(name, "=\"").concat(xss.escapeAttrValue(value), "\"") : undefined;
        }
      })
    }
  });
};

var truncate = memo(Truncate);

export { truncate as default };
//# sourceMappingURL=truncate-esm.js.map
